import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { RequestQueryBuilder } from "@nestjsx/crud-request";
import { format, setHours, setMinutes } from "date-fns";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Center } from "../../../../components/center";
import { ErrorPanel } from "../../../../components/error_panel";
import { Loading } from "../../../../components/loading";
import { IAsyncData, IRange } from "../../../../core/models";
import { isError, isPending, isSuccess } from "../../../../core/redux";
import { Routing } from "../../../../core/routing";
import { fixAmount } from "../../../../core/utils";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { transactionTypeToString } from "../../../transaction/data/models";
import { IProductHistory } from "../../data/entities";
import { productHistoryReduxActions } from "../state/state";

export interface ISingleProductFilter {
  productId: string;
  createdDateRange?: IRange<Date>;
}

export function singleProductFilterToQueryParams(filter: ISingleProductFilter): string {
  const qb = RequestQueryBuilder.create();

  if (filter.createdDateRange?.from) {
    qb.setFilter({
      field: "createdDate",
      operator: "$gte",
      value: format(setMinutes(setHours(filter.createdDateRange?.from, 0), 0), "yyyy-MM-dd HH:mm"),
    });
  }

  if (filter.createdDateRange?.to) {
    qb.setFilter({
      field: "createdDate",
      operator: "$lte",
      value: format(setMinutes(setHours(filter.createdDateRange?.to, 23), 59), "yyyy-MM-dd HH:mm"),
    });
  }

  qb.setFilter({
    field: "product",
    operator: "$eq",
    value: filter.productId,
  });

  qb.sortBy({ field: "id", order: "DESC" });

  return qb.query(false);
}

interface IProps {
  productId: string;
}

export const SingleProductHistoryList: React.FC<IProps> = ({ productId }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const search = history.location.search || `?${singleProductFilterToQueryParams({ productId })}`;

  useEffect(() => {
    dispatch(productHistoryReduxActions.getList(search));
  }, [dispatch, search]);
  const productHistoryListBranch = useSelector<IAppReduxState, IAsyncData<IProductHistory[]>>(
    (state) => state.productHistory.list,
  );

  return (
    <Box mt={3}>
      <Loading loading={isPending(productHistoryListBranch)}>
        <Paper>
          <Table size="medium" className="list-table">
            <TableHead>
              <TableRow>
                <TableCell>Qiymet evvel</TableCell>
                <TableCell>Əməliyyat novu</TableCell>
                <TableCell>Qiymet sonra</TableCell>
                <TableCell>Tarix</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productHistoryListBranch.data?.map((productHistory) => {
                return (
                  <TableRow
                    hover
                    key={productHistory.id}
                    onClick={() => {
                      history.push(Routing.generateDetailRoute(ROUTES.transaction, productHistory.transaction.id));
                    }}
                  >
                    <TableCell>{fixAmount(productHistory.priceBefore)} AZN</TableCell>
                    <TableCell>{transactionTypeToString(productHistory.transaction.type)}</TableCell>
                    <TableCell>{fixAmount(productHistory.priceAfter)} AZN</TableCell>
                    <TableCell>{format(productHistory.createdDate, "dd MMMM yyyy HH:mm")}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

          {isError(productHistoryListBranch) && (
            <Center>
              <Box py={3}>
                <ErrorPanel branch={productHistoryListBranch} />
              </Box>
            </Center>
          )}

          {isSuccess(productHistoryListBranch) && productHistoryListBranch.data?.length === 0 && (
            <Center>
              <Box py={3}>
                <Typography>Məlumat yoxdur</Typography>
              </Box>
            </Center>
          )}
        </Paper>
      </Loading>
    </Box>
  );
};
